<template>
  <div id="contenedor-reportes-fisicos-listado-partidas">
    <v-list
      two-line>
      <template
        v-for="(partida, index) in partidas">
        <template
          v-if="partida.ponderadoPartida > 0">
          <v-list-item
            :key="partida.id"
            link>
            <v-list-item-action>
              <v-chip
                small
                :color="partida.fueReportada ? 'orange' : ''"
                :dark="partida.fueReportada"
                :disabled="partida.avanceFisico === 100 && !partida.fueReportada">
                <b>{{ partida.avanceFisico }}%</b>
                <v-icon
                  v-if="partida.fueReportada"
                  right
                  small>
                  trending_up
                </v-icon>
              </v-chip>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ partida.clave }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ partida.concepto }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <template
                  v-if="partida.fueReportada">
                  <div id="contenedor-album-fotografico">
                    <v-row justify="start">
                      <template
                        v-for="(imagen, index) in getImagenesPartida(partida)">
                        <template>
                          <v-col
                            cols="auto"
                            class="pa-1"
                            :key="`img-${index}`">
                            <v-img
                              :src="getUrlImagen(imagen)"
                              height="50"
                              width="50"
                              contain
                              class="blue-grey darken-4">
                            </v-img>
                          </v-col>
                        </template>
                      </template>
                    </v-row>
                  </div>
                </template>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action
              class="mr-2">
              <v-chip
                small
                color="success"
                dark>
                <small class="mr-1">Ponderado:</small>
                <b>{{ partida.ponderadoPartida | number('0.00') }}%</b>
              </v-chip>
            </v-list-item-action>
            <v-list-item-action
              class="mr-2">
              <v-chip
                small
                color="azul2"
                dark>
                <small class="mr-1">Avance:</small>
                <b>{{ partida.avancePonderado }}%</b>
              </v-chip>
            </v-list-item-action>
            <template
              v-if="!partida.fueReportada">
              <v-list-item-action>
                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click.prevent="reportarPartida(partida)">
                      <v-icon>add</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Reportar partida
                  </span>
                </v-tooltip>
              </v-list-item-action>
            </template>
            <template
              v-else>
              <v-list-item-action>
                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="editarPartidaReportada(partida)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Editar partida
                  </span>
                </v-tooltip>
              </v-list-item-action>
              <v-list-item-action v-if="!ocultarRemover">
                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click.prevent="removerPartidaReportada(partida)">
                      <v-icon>remove</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Remover partida
                  </span>
                </v-tooltip>
              </v-list-item-action>
            </template>
          </v-list-item>
        </template>
        <template
          v-else>
          <v-list-item
            :key="partida.id"
            disabled>
            <v-list-item-content>
              <v-list-item-title>
                {{ partida.clave }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ partida.concepto }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template
          v-if="(index + 1) < partidas.length">
          <v-divider :key="`${partida.id}-divider`"></v-divider>
        </template>
      </template>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'ReportesFisicoListadoPartidas',
  props: {
    partidas: {
      type: Array,
      required: true,
    },
    partidasImagenes: {
      type: Array,
      required: false,
    },
    ocultarRemover: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    getUrlImagen(imagen) {
      if (typeof (imagen) === 'string') {
        const url = `${this.$urlFileServer}/${imagen}`;
        return url;
      }
      const url = URL.createObjectURL(imagen);
      return url;
    },
    getImagenesPartida(partida) {
      const imagenesPartida = this.getPartidasImagenes
        .find(({ idPartida }) => idPartida === partida.id);
      if (typeof (imagenesPartida.imagenes) === 'string') {
        return JSON.parse(imagenesPartida.imagenes);
      }
      return imagenesPartida.imagenes;
    },
    reportarPartida(partida) {
      this.$emit('reportarPartida', partida);
    },
    editarPartidaReportada(partida) {
      this.$emit('editarPartidaReportada', partida);
    },
    removerPartidaReportada(partida) {
      this.$emit('removerPartidaReportada', partida);
    },
  },
  computed: {
    getPartidasImagenes() {
      if (!this.partidasImagenes) return [];
      const partidasConImagenes = [];
      this.partidasImagenes.forEach((partida) => {
        partidasConImagenes.push({
          ...partida,
        });
      });
      return partidasConImagenes;
    },
  },
};
</script>

<style lang="scss">

</style>
